import { useQuery } from "@tanstack/react-query";
import { fetchPublications, type Publication } from "@/lib/api/publications";

export function usePublications() {
  return useQuery<Publication[]>({
    queryKey: ["publications"],
    queryFn: fetchPublications,
    staleTime: 5 * 60_000,
  });
}

/** Group publications by year, newest first. */
export function groupByYear(items: readonly Publication[]): Array<[number, Publication[]]> {
  const byYear = new Map<number, Publication[]>();
  for (const p of items) {
    const bucket = byYear.get(p.year) ?? [];
    bucket.push(p);
    byYear.set(p.year, bucket);
  }
  return [...byYear.entries()].sort(([a], [b]) => b - a);
}
